import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
} from "@@/shared/date-time/iso-and-unix";

import { idZodSchema } from "@@/shared/id";
import type {
    OrderGroupId} from "@@/shared/order-groups/order-group-id";
import {
    orderGroupIdZodSchema,
} from "@@/shared/order-groups/order-group-id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import { z } from "zod";
import type { OrderId} from "../order-id";
import { orderIdZodSchema } from "../order-id";

type OrderCommandCommon = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly orderGroupId: OrderGroupId;
    readonly orderId: OrderId;
    readonly providerId: ProviderId;
};

const orderCommandCommonZodSchema: z.ZodSchema<OrderCommandCommon> = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    orderGroupId: orderGroupIdZodSchema,
    orderId: orderIdZodSchema,
    providerId: providerIdZodSchema,
});

export { orderCommandCommonZodSchema };
export type { OrderCommandCommon };
